import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { CancelRounded } from '@material-ui/icons';
import MagicQRCode from './MagicQRCode';
import BasicModal from '../../../../../modules/modals/BasicModal';
import { getBackgroundTheme } from '../../../../../style';
import { CloseBtn, closeButton } from '../../../../common/CommonStyle';

const QRCodeModal = ({ isOpen, handleClose, isJoinFlow }) => {
  return (
    <BasicModal
      isOpen={isOpen}
      hideClose={true}
      customStyle={{
        content: {
          borderRadius: '25px',
          padding: '25px 30px 40px 30px',
          maxWidth: 400,
          backgroundColor: getBackgroundTheme().fsModal,
          zIndex: 100002,
        },
        overlay: {
          zIndex: 100002,
        },
      }}
      onClose={handleClose}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <CloseBtn data-test-id={`qr-code-modal-close`} onClick={handleClose} style={{ top: '-50px', right: '-6px' }}>
        <SvgIcon component={CancelRounded} style={closeButton} />
      </CloseBtn>
      <MagicQRCode customStyle={{ margin: '50px 0px 0px 0px' }} isJoinFlow={isJoinFlow} />
    </BasicModal>
  );
};

export default QRCodeModal;
